var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vrm-avatar-stack"},[_vm._l((_vm.visibleUsers),function(user,index){return _c('vrm-avatar',{key:user.id,style:(_vm.overlapStyle(index)),attrs:{"user":user,"admin-key":_vm.adminKey}})}),(_vm.hiddenCount)?_c('span',{staticClass:"vrm-avatar-stack__hidden"},[_vm._v("+ "+_vm._s(_vm.hiddenCount))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }